import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.signup');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-signup',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.signup/view.scss */
/* src/app/page.signup/view.scss: no such file or directory */`],
})
export class PageSignupComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(false, "/main");
    }

    public status: any = false;
    public data: any = {
        email: '',
        password: '',
        confirmPassword: '',
        name: '',
        phone: '',
        department: '',
        position: ''
    };

    public validation: any = {
        email: '',
        password: '',
        confirmPassword: '',
        name: '',
        phone: '',
        department: '',
        position: ''
    };

    public async alert(message: string, status: string = 'error') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: "확인",
            status: status
        });
    }

    public async submit() {
        this.resetValidation();

        if (!this.validateEmail(this.data.email)) {
            this.validation.email = '올바른 이메일 형식이 아닙니다.';
        }

        if (this.data.password.length < 6) {
            this.validation.password = '비밀번호는 최소 6자 이상이어야 합니다.';
        }

        if (this.data.password !== this.data.confirmPassword) {
            this.validation.confirmPassword = '비밀번호가 일치하지 않습니다.';
        }

        if (!this.data.name) {
            this.validation.name = '이름을 입력해주세요.';
        }

        if (!this.validatePhone(this.data.phone)) {
            this.validation.phone = '올바른 전화번호 형식이 아닙니다.';
        }

        if (!this.data.department) {
            this.validation.department = '부서를 입력해주세요.';
        }

        if (!this.data.position) {
            this.validation.position = '직급을 입력해주세요.';
        }

        if (Object.values(this.validation).some(error => error)) {
            return;
        }

        let user = JSON.parse(JSON.stringify(this.data));
        user.password = this.service.auth.hash(user.password);

        let { code, data } = await wiz.call("submit", user);
        if (code == 200) {
            await this.alert("회원가입이 완료되었습니다.", "success");
            await this.service.render();
            location.href = "/login";
            return;
        }
        await this.alert(data);
    }



    private resetValidation() {
        this.validation = {
            email: '',
            password: '',
            confirmPassword: '',
            name: '',
            phone: '',
        };
    }

    private validateEmail(email: string): boolean {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\.,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,})$/i;
        return re.test(String(email).toLowerCase());
    }

    private validatePhone(phone: string): boolean {
        const re = /^\d{3}-\d{3,4}-\d{4}$/;
        return re.test(String(phone));
    }

    public formatPhone() {
        const trimmed = this.data.phone.replace(/\D+/g, '');

        if (trimmed.length === 11) {
            this.data.phone = trimmed.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
        } else if (trimmed.length === 10) {
            this.data.phone = trimmed.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        }
    }
}

export default PageSignupComponent;